import { reducers as coreReducers } from "@sf-core";
import { reducers as adminReducers } from "../../areas/admin";
import { reducers as analyticsReducers } from "../../areas/analytics";
import { reducers as fileUploadReducers } from "@sf-fileUpload";

export const reducers = {
  ...coreReducers,
  ...adminReducers,
  ...analyticsReducers,
  ...fileUploadReducers,
};
